import { defaultInitialStep } from "../consts";
import { DialogModule } from "../v1";
import { storySchema, IStory } from "./story";

export const isStoryValid = (story: IStory): boolean => {
  return storySchema.isValidSync(story);
}

export const getValidationError = (story: IStory): Error | undefined => {
  if (isStoryValid(story)) {
    return undefined;
  }
  
  try {
    storySchema.validateSync(story);
    // should never get here
    return undefined;
  } catch(e: any) {
    return e as Error;
  }
}

// export const validateNavigation = (story: DialogModule) => {
//   return testStepsNavigation(story.initialStep).validateSync(story.steps);
// }

// export const isCharacterdIdValid = (possiblyCharId: string): boolean => {
//   return characterId.isValidSync(possiblyCharId);
// }

// Export V1
export { isStoryBroken } from '../v1/validation';
// @NOTE: This might have to be updated as needed
const storyConfig = {
  charSlots: 3,
  propsLength: 6,
}

export const isStoryBrokenV2 = (story: IStory, verbose: boolean = false): boolean => {
  verbose && console.info('isStoryBrokenV2', story);
  const keys = Object.keys(story);
  try {
    if (keys.length !== storyConfig.propsLength) {
      return true;
    }
    return false;
  } catch {
    return true;
  }
}

export const isSchemaV2 = (storyOrDialog: IStory | DialogModule) => {
  const possiblyStory = storyOrDialog as any;
  // DialogModule has version in the root so not v2
  if (possiblyStory.version) {
    return false;
  }

  return Number(possiblyStory.metadata?.version) > 12;
}

